import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import DateTimePicker from '../../misc/DateTimePicker';


const inputStyles = (props) => {
  return `
    display: flex;
    align-items: center;
    height: 100%;
    width:${props.width};
    background-color: ${props.backgroundColor};
    font-size: ${props.fontSize}px !important;
    color: ${props.fontColor};
    font-style: ${props.fontStyle};
    font-weight: ${props.fontWeight};
    text-align: ${props.textAlign};
    text-transform: ${props.textTransform};
    text-decoration: ${props.textDecoration};
    ${props.textOverflow ? `text-overflow: ${props.textOverflow};` : ''}
    border-radius: ${props.borderRadius}px;
    border: ${props.border};
    resize: none;
    transition: border 0.15s ease-in-out;

    &:focus, &:focus-visible {
      outline: unset;
      border: ${props.borderWidth}px solid ${props.primaryColor};
    }

    &:hover {
      ${props.disabled ? '' : `border: ${props.borderWidth}px solid ${props.primaryColor}`};
    }
    
    min-height: ${(props) => props.minHeight ? `${props.minHeight}px`: ''}

  `;
};


const StyledSpan = styled.span`
  ${(props) => inputStyles(props)}
`;

/**
 * Why didn't I use a functional component here?
 *
 * The unmount functionality with the useEffect doesn't allow me
 * to access the focused and changes state that I needed. Inside
 * of the useEffect cleanup it always showed both these values
 * as undefined.
 *
 */
class FieldDateInput extends React.PureComponent {

  static propTypes = {

    tz: PropTypes.string,
    disabled: PropTypes.bool,
    format: PropTypes.string,
    enableTimezoneAnchor: PropTypes.bool,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),

    //Styles
    primaryColor: PropTypes.string,
    fontSize: PropTypes.number,
    fontColor: PropTypes.string,
    fontStyle: PropTypes.string,
    fontWeight: PropTypes.string,
    textAlign: PropTypes.string,
    textTransform: PropTypes.string,
    textDecoration: PropTypes.string,
    textOverflow: PropTypes.string,
    borderColor: PropTypes.string,
    borderRadius: PropTypes.number,
    borderWidth: PropTypes.number,
    backgroundColor: PropTypes.string,

  }

  static defaultProps = {
    value: '',
  }

  constructor(props) {
    super(props);
    this.state = { focused: false };
  }

  render() {

    const {

      value,
      disabled,
      format,
      timezone,

      primaryColor,

      //Field style
      fontSize,
      fontColor,
      fontStyle,
      fontWeight,
      textAlign,
      textTransform,
      textDecoration,
      textOverflow,
      borderColor,
      borderRadius,
      borderWidth,
      backgroundColor,
      padding,

      onChange,
      onClick,
      onClose,

    } = this.props;

    const customStyles = {
      border: `${borderWidth}px solid ${borderColor}`,
      fontSize,
      fontColor,
      fontStyle,
      fontWeight,
      textAlign,
      textTransform,
      textDecoration,
      textOverflow,
      borderColor,
      borderRadius,
      borderWidth,
      backgroundColor,
      padding,
      primaryColor,
    };

    return (
      <StyledSpan {...customStyles}>
        <DateTimePicker
          disabled={disabled}
          customStyles={customStyles}
          value={value}
          timezone={timezone}
          enableTimezoneAnchor={true}
          format={format}
          onChange={onChange}
          onClick={onClick}
          onClose={onClose}
        />
      </StyledSpan>
    );
  }
  
}

export default FieldDateInput;